import '../assets/NcSettingsSelectGroup-D8mlvzIT.css';
import { N as i } from "./NcSelect-Bo71Yd6L.mjs";
import { r as l, e as n, a } from "./_l10n-BaNxGGXy.mjs";
import { G as o } from "./GenRandomId-BW3iYFf9.mjs";
import u from "@nextcloud/axios";
import p from "debounce";
import { generateOcsUrl as d } from "@nextcloud/router";
import { n as c } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
l(n);
const m = {
  name: "NcSettingsSelectGroup",
  components: {
    NcSelect: i
  },
  props: {
    /**
     * The text of the label element of the select group input
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Placeholder for the input element
     * For backwards compatibility it falls back to the `label` value
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * id attribute of the select group element
     */
    id: {
      type: String,
      default: () => "action-" + o(),
      validator: (r) => r.trim() !== ""
    },
    /**
     * value of the select group input
     * A list of group IDs can be provided
     */
    value: {
      type: Array,
      default: () => []
    },
    /**
     * disabled state of the settings select group input
     */
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "input",
    "error"
  ],
  data() {
    return {
      /** Temporary store to cache groups */
      groups: {},
      randId: o(),
      errorMessage: ""
    };
  },
  computed: {
    /**
     * If the error message should be shown
     */
    hasError() {
      return this.errorMessage !== "";
    },
    /**
     * Validate input value and only return valid strings (group IDs)
     *
     * @return {string[]}
     */
    filteredValue() {
      return this.value.filter((r) => r !== "" && typeof r == "string");
    },
    /**
     * value property converted to an array of group objects used as input for the NcSelect
     */
    inputValue() {
      return this.filteredValue.map(
        (r) => typeof this.groups[r] > "u" ? {
          id: r,
          displayname: r
        } : this.groups[r]
      );
    },
    /**
     * Convert groups object to array of groups required for NcSelect.options
     * Filter out currently selected values
     *
     * @return {object[]}
     */
    groupsArray() {
      return Object.values(this.groups).filter((r) => !this.value.includes(r.id));
    }
  },
  watch: {
    /**
     * If the value is changed, check that all groups are loaded so we show the correct display name
     */
    value: {
      handler() {
        const r = Object.keys(this.groups);
        this.filteredValue.filter((t) => !r.includes(t)).forEach((t) => {
          this.loadGroup(t);
        });
      },
      // Run the watch handler also when the component is initially mounted
      immediate: !0
    }
  },
  /**
   * Load groups matching the empty query to reduce API calls
   */
  async mounted() {
    const r = "".concat(appName, ":").concat(appVersion, "/initialGroups");
    let e = window.sessionStorage.getItem(r);
    e ? (e = Object.fromEntries(JSON.parse(e).map((t) => [t.id, t])), this.groups = { ...this.groups, ...e }) : (await this.loadGroup(""), window.sessionStorage.setItem(r, JSON.stringify(Object.values(this.groups))));
  },
  methods: {
    t: a,
    /**
     * Called when a new group is selected or previous group is deselected to emit the update event
     *
     * @param {object[]} updatedValue Array of selected groups
     */
    update(r) {
      const e = r.map((t) => t.id);
      this.$emit("input", e);
    },
    /**
     * Use provisioning API to search for given group and save it in the groups object
     *
     * @param {string} query The query like parts of the id oder display name
     * @return {boolean}
     */
    async loadGroup(r) {
      try {
        r = typeof r == "string" ? encodeURI(r) : "";
        const e = await u.get(d("cloud/groups/details?search=".concat(r, "&limit=10"), 2));
        if (this.errorMessage !== "" && window.setTimeout(() => {
          this.errorMessage = "";
        }, 5e3), Object.keys(e.data.ocs.data.groups).length > 0) {
          const t = Object.fromEntries(e.data.ocs.data.groups.map((s) => [s.id, s]));
          return this.groups = { ...this.groups, ...t }, !0;
        }
      } catch (e) {
        this.$emit("error", e), this.errorMessage = a("Unable to search the group");
      }
      return !1;
    },
    /**
     * Custom filter function for `NcSelect` to filter by ID *and* display name
     *
     * @param {object} option One of the groups
     * @param {string} label The label property of the group
     * @param {string} search The current search string
     */
    filterGroups(r, e, t) {
      return "".concat(e || "", " ").concat(r.id).toLocaleLowerCase().indexOf(t.toLocaleLowerCase()) > -1;
    },
    /**
     * Debounce the group search (reduce API calls)
     */
    onSearch: p(function(r) {
      this.loadGroup(r);
    }, 200)
  }
};
var f = function() {
  var e = this, t = e._self._c;
  return t("div", [e.label ? t("label", { staticClass: "hidden-visually", attrs: { for: e.id } }, [e._v(e._s(e.label))]) : e._e(), t("NcSelect", { attrs: { value: e.inputValue, options: e.groupsArray, placeholder: e.placeholder || e.label, "filter-by": e.filterGroups, "input-id": e.id, limit: 5, label: "displayname", multiple: !0, "close-on-select": !1, disabled: e.disabled }, on: { input: e.update, search: e.onSearch } }), t("div", { directives: [{ name: "show", rawName: "v-show", value: e.hasError, expression: "hasError" }], staticClass: "select-group-error" }, [e._v(" " + e._s(e.errorMessage) + " ")])], 1);
}, h = [], g = /* @__PURE__ */ c(
  m,
  f,
  h,
  !1,
  null,
  "6d99b3e0",
  null,
  null
);
const N = g.exports;
export {
  N
};
